export const featuredPortfolio = [
  {
    id: 1,
    link: "https://drive.google.com/drive/folders/1JO1Jz1gFmTcK6EzZc6dLo9WTV1YcYiFu?usp=sharing",
    title: "ITGEEKS Admin Panel",
    img: "assets/website1.png",
  },
  {
    id: 2,
    link: "https://github.com/adeelbaig625/Redux-ecommerce.git",
    title: "Ecommerce web",
    img: "assets/e-commerceweb.png",
  },
  {
    id: 3,
    link: "https://drive.google.com/drive/folders/1JO1Jz1gFmTcK6EzZc6dLo9WTV1YcYiFu?usp=sharing",
    title: "ITGEEKS App",
    img: "assets/MobileApp.jpg",
  },
  {
    id: 5,
    link: "https://dataco-sigma.vercel.app/",
    title: "Landing website",
    img: "assets/dataco.png",
  },
  {
    id: 5,
    link: "https://adscomex.com/",
    title: "AdsComex Website",
    img: "assets/AdsComex.png",
  },
];

export const webPortfolio = [
  {
    id: 1,
    link: "https://drive.google.com/drive/folders/1JO1Jz1gFmTcK6EzZc6dLo9WTV1YcYiFu?usp=sharing",
    title: "Ecommerce Admin Panel",
    img: "assets/website1.png",
  },
  {
    id: 2,
    link: "https://ads-comex.vercel.app/",
    title: "AdsComex Website",
    img: "assets/AdsComex.png",
  },
  {
    id: 3,
    link: "https://github.com/adeelbaig625/ChatWeb-Sokcet.io-.git",
    title: "Chat web",
    img: "assets/chatcordmockup.png",
  },
  {
    id: 4,
    link: "https://adscomex.com/",
    title: "Ecommerce web",
    img: "assets/e-commerceweb.png",
  },
  {
    id: 5,
    link: "https://dataco-sigma.vercel.app/",
    title: "Landing website",
    img: "assets/dataco.png",
  },
];

export const HybridApp = [
  {
    id: 1,
    link: "https://drive.google.com/drive/folders/1JO1Jz1gFmTcK6EzZc6dLo9WTV1YcYiFu?usp=sharing",
    title: "Ecommere App",
    img: "assets/MobileApp.jpg",
  },
  {
    id: 2,
    title: "Finance App",
    img: "assets/CashPotato.png",
  },
];
